/* SessionStatusIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D");


import React from 'react';
import { useIntl } from 'react-intl';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { messages } from './messages';
import { SessionAnimatedIndicator } from './SessionAnimatedIndicator';
const styles = {
  indicator: "_3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg"
};
export type SessionStatusIndicatorProps = {
  /** Presentation status selected by the owning session component. */
  status?: 'working' | 'needs-input' | 'unread';
  /** Retained for existing callers; needs input now always uses a blue dot. */
  requiresInputAppearance?: 'badge' | 'icon';
  /** Hide the indicator from assistive technology when visible status text names the state. */
  decorative?: boolean;
  testId?: string;
};

/** Renders the selected session status indicator. */
export const SessionStatusIndicator = ({
  status,
  decorative = false,
  testId
}: SessionStatusIndicatorProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  if (status === undefined) {
    return null;
  }
  return <Inline as="span" alignBlock="center" alignInline="center" aria-hidden={decorative || undefined} role={status === 'unread' ? 'img' : undefined} aria-label={status === 'unread' ? formatMessage(messages.unreadSessionLabel) : undefined} xcss={styles.indicator} testId={testId}>
			{/* Both dot states share one visual; unread owns its accessible name above. */}
			<Inline as="span" alignBlock="center" aria-hidden={status === 'unread' || undefined}>
				<SessionAnimatedIndicator indicatorType={status === 'working' ? 'working' : 'dot'} />
			</Inline>
		</Inline>;
};